<template>
  <div class="user-overview">
    <!--<div v-if="!investorEnabled" class="verify-guide">-->
    <!--<div class="guide-text">-->
    <!--<div>{{ $t('guideTextTop') }}</div>-->
    <!--<div>{{ $t('guideTextBottom') }}</div>-->
    <!--</div>-->
    <!--<div class="guide-button">-->
    <!--<md-button @click="goVerify">{{ $t('doItNow') }}</md-button>-->
    <!--</div>-->
    <!--</div>-->
    <div class="overview-banner">
      <div class="title">{{ $t('hello') }},</div>
      <div class="user-name">{{ userInfo.fullName || $t('visitor')}}</div>
      <div class="user-phone">{{ userInfo.mobileNumber }}</div>
    </div>
    <div class="overview-container">
      <div class="card capital">
        <div class="total-balance">
          <div class="number">{{ totalBalance | formatMoney(investorEnabled) }}</div>
          <div class="label">{{ $t('totalBalance') }}</div>
        </div>
        <div class="revenue">
          <div class="yesterday">
            <div class="number">
              {{ yesterdayRevenue | formatMoney(investorEnabled) }}
            </div>
            <div class="label">{{ $t('yesterdayRevenue') }}</div>
          </div>
          <div class="cumulative">
            <div class="number">{{ cumulativeRevenue | formatMoney(investorEnabled) }}</div>
            <div class="label">{{ $t('cumulativeRevenue') }}</div>
          </div>
        </div>
      </div>
      <div class="card unused-balance">
        <div class="balance">
          <div class="balance-amount">
            <!--<div class="extra-amount">+ {{ extraBalance }}</div>-->
            <div class="number">{{ accountInfo.balance ? accountInfo.balance : 0 | formatMoney(investorEnabled) }}</div>
            <div class="label">{{ $t('unusedBalance') }}</div>
          </div>
          <div class="btn-container">
            <div class="btn-item" v-if="topupVisible">
              <md-button type="primary" round :inactive="!investorEnabled" @click="goTopup">
                {{ $t('topUp')}}
              </md-button>
            </div>
            <div class="btn-item withdraw">
              <md-button type="primary" plain round :inactive="!investorEnabled"
                         @click="goWithdraw()">
                {{ $t('withdraw')}}
              </md-button>
            </div>
          </div>
        </div>
        <div class="tip" v-if="investorEnabled">
          <md-icon name="info" size="sm"></md-icon>
          {{ $t('balanceTip') }}
        </div>
      </div>
      <div v-if="investorEnabled">
        <div class="investment-title">
          {{ $t('investmentTitle') }}
        </div>
        <div v-if="flexibleData.capitalSum" class="card invest invest-flexible"
             @click="switchRoute('UserRecordList','flexible')">
          <div class="invest-title">
            <img src="@/assets/image/user/icon-flexible.png" class="invest-title-icon">
            {{ $t('flexibleInvestment') }}
          </div>
          <div class="invest-content">
            <div class="balance">
              <div class="number">
                {{ flexibleBalance| formatMoney }}
              </div>
              <div class="label">{{ $t('balance') }}</div>
            </div>
            <div class="revenue">
              <div class="number">{{ flexibleData.revenueSum + flexibleData.extraRevenueSum | formatMoney }}</div>
              <div class="label">{{ $t('totalRevenue') }}</div>
            </div>
          </div>
        </div>
        <div class="card invest invest-fixed" @click="switchRoute('UserRecordList', 'fixed')">
          <div class="invest-title">
            <img src="@/assets/image/user/icon-fixed.png" class="invest-title-icon">
            {{ $t('fixedInvestment') }}
          </div>
          <div class="invest-content">
            <div class="balance">
              <div class="number">
                {{ fixedBalance | formatMoney }}
              </div>
              <div class="label">{{ $t('balance') }}</div>
            </div>
            <div class="revenue">
              <div class="number">{{ fixedData.revenueSum + fixedData.extraRevenueSum | formatMoney }}</div>
              <div class="label">{{ $t('expectReturn') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="card account-status">
        <verification-result :status="$store.state.userInfo.status"></verification-result>
      </div>
      <verify-guide-dialog
        :visible="verfifyDialogVisible"
        :isWithdraw="isWithdraw"
        @hideDialog="verfifyDialogVisible = false"
      ></verify-guide-dialog>
      <bind-bank-dialog
        :visible="bindBankDialogVisible"
        :title="bindBankTitle"
        @hideDialog="hideBindBankDialog"
      ></bind-bank-dialog>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'
import VerificationResult from '@/components/common/VerificationResult'
import VerifyGuideDialog from '@/components/common/VerifyGuideDialog'
import bindBankMixin from '@/mixins/bind-bank'

export default {
  i18n: {
    messages: {
      en: {
        guideTextTop: 'For your safety,',
        guideTextBottom: 'please complete onboarding process',
        doItNow: 'Do It Now',
        hello: 'Hello',
        visitor: 'Visitor',
        totalBalance: 'Total Balance',
        yesterdayRevenue: 'Yesterday Revenue',
        cumulativeRevenue: 'Cumulative Revenue',
        unusedBalance: 'Unused balance',
        topUp: 'Top up',
        withdraw: 'Withdraw',
        balanceTip: 'If funds aren\'t used within 48 hours, it will be refunded',
        investmentTitle: 'My Investment',
        flexibleInvestment: 'Flexible Investment',
        balance: 'balance',
        totalRevenue: 'Total Revenue',
        fixedInvestment: 'Fixed Term Investment',
        expectReturn: 'Total Revenue',
        withdrawBindBankTitle: 'To withdraw money you have to fill out your bank account first',
      },
      id: {
        guideTextTop: 'Demi keamanan akun Anda,',
        guideTextBottom: 'silahkan menyelesaikan proses verifikasi data',
        doItNow: 'Lakukan sekarang',
        hello: 'Halo',
        visitor: 'Visitor',
        totalBalance: 'Nominal',
        yesterdayRevenue: 'Pendapatan Kemarin',
        cumulativeRevenue: 'Pendapatan Kumulatif',
        unusedBalance: 'Sisa nominal',
        topUp: 'Salurkan Dana',
        withdraw: 'Tarik Dana',
        balanceTip: 'Nominal akan dikembalikan jika tidak digunakan dalam 48 jam',
        investmentTitle: 'Pendanaanku',
        flexibleInvestment: 'Pendanaan Fleksibel',
        balance: 'Nominal',
        totalRevenue: 'Total Pendapatan',
        fixedInvestment: 'Pendanaan Berjangka',
        expectReturn: 'Total Pendapatan',
        withdrawBindBankTitle: 'Untuk menarik nominal silahkan mengisi akun bank terlebih dahulu',
      },
    },
  },
  components: {
    [Button.name]: Button,
    VerificationResult,
    VerifyGuideDialog,
  },
  mixins: [
    bindBankMixin,
  ],
  data() {
    return {
      flexibleData: {
        capitalSum: 0,
        revenueSum: 0,
        totalRevenueSum: 0,
        yesterdayRevenue: 0,
        extraAmountSum: 0,
        extraRevenueSum: 0,
        extraYesterdayRevenue: 0,
        extraTotalRevenueSum: 0,
      },
      fixedData: {
        capitalSum: 0,
        revenueSum: 0,
        totalRevenueSum: 0,
        yesterdayRevenue: 0,
        extraAmountSum: 0,
        extraRevenueSum: 0,
        extraYesterdayRevenue: 0,
        extraTotalRevenueSum: 0,
      },
      verfifyDialogVisible: false,
      isWithdraw: false,
      bindBankFrom: '',
      topupVisible: true, // !this.$config.needElectronicContract || window.birdge,
    }
  },
  computed: {
    investorEnabled() {
      return this.$store.state.userInfo.status === 'ENABLED'
    },
    userInfo() {
      return this.$store.state.userInfo || {}
    },
    verifyStatus() {
      return this.userInfo.status
    },
    isVerifyPending() {
      return this.verifyStatus === 'PENDING'
    },
    accountInfo() {
      const accountInfo = this.$store.state.accountOverview.find(i => i.currencyType === 'IDR')
      return accountInfo || {}
    },
    yesterdayRevenue() {
      return this.fixedData.yesterdayRevenue + this.flexibleData.yesterdayRevenue + this.fixedData.extraYesterdayRevenue + this.flexibleData.extraYesterdayRevenue || 0
    },
    cumulativeRevenue() {
      return this.flexibleData.totalRevenueSum + this.fixedData.totalRevenueSum + this.flexibleData.extraTotalRevenueSum + this.fixedData.extraTotalRevenueSum
    },
    flexibleBalance() {
      return this.flexibleData.capitalSum + this.flexibleData.revenueSum + this.flexibleData.extraAmountSum + this.flexibleData.extraRevenueSum
    },
    fixedBalance() {
      return this.fixedData.capitalSum + this.fixedData.revenueSum + this.fixedData.extraAmountSum + this.fixedData.extraRevenueSum
    },
    totalBalance() {
      return this.accountInfo.balance + this.flexibleBalance + this.fixedBalance
    },
    extraBalance() {
      // todo add extra balance
      return 39
    },
    needVerify() {
      return this.verifyStatus !== 'ENABLED'
    },
    bindBankTitle() {
      return this.bindBankFrom === 'UserTopup' ? '' : this.$t('withdrawBindBankTitle')
    },
  },
  async mounted() {
  },
  methods: {
    reloadData() {
      this.reloadCapitalInfo()
    },
    async reloadCapitalInfo() {
      try {
        const response = await this.$http.get('/order/capital-and-revenue-sum')
        const data = response.data.data
        this.flexibleData = data.flexibleOrder.find(i => i.currencyType === 'IDR') || {
          capitalSum: 0,
          revenueSum: 0,
          totalRevenueSum: 0,
          yesterdayRevenue: 0,
          extraAmountSum: 0,
          extraRevenueSum: 0,
          extraYesterdayRevenue: 0,
          extraTotalRevenueSum: 0,
        }
        this.fixedData = data.fixedOrder.find(i => i.currencyType === 'IDR') || {
          capitalSum: 0,
          revenueSum: 0,
          totalRevenueSum: 0,
          yesterdayRevenue: 0,
          extraAmountSum: 0,
          extraRevenueSum: 0,
          extraYesterdayRevenue: 0,
          extraTotalRevenueSum: 0,
        }
      } catch (error) {
        console.error(error)
      }
    },
    goVerify() {
      this.switchRoute(this.isVerifyPending ? 'SignupResult' : 'SignupAdditional')
    },
    goTopup() {
      /**
       * KYC通过但银行卡绑定状态未通过的，跳转到绑卡页面
       * 否则跳转充值页面
       */
      if (this.$config.needBindBankPrevious && this.userInfo.bankAccountStatus === 'PASSED') {
        this.switchRoute('UserTopup')
      } else {
        this.bindBankFrom = 'UserTopup'
        this.bindBankDialogVisible = true
      }
    },
    goWithdraw() {
      /**
       * 银行卡状态未通过的，跳转到绑卡页面
       * 否则跳转提现页面
       */
      if (this.userInfo.bankAccountStatus === 'PASSED') {
        this.switchRoute('UserWithdraw')
      } else {
        this.bindBankFrom = 'UserWithdraw'
        this.bindBankDialogVisible = true
      }
    },
    switchRoute(name, type) {
      if (type) {
        this.$router.push({ name: name, params: { type: type } })
      } else {
        this.$router.push({ name: name })
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.investorEnabled) {
        vm.reloadData()
      }
    })
  },
}
</script>

<style lang="stylus" scoped>
.user-overview {
  padding-bottom: 64px;
}

.verify-guide {
  background-color: #67809F;
  color: #fff;
  padding: 15px 22px;
  display: flex;
  justify-content: space-between;
  .guide-text {
    font-size: 12px;
    line-height: 1.25em;
    div {
      font-weight: bold;
    }
  }
  .guide-button /deep/ {
    width: 80px;
    .md-button {
      height: 26px;
      background-color: #fff;
      color: #67809F;
      font-weight: 600;
    }
  }
}

.label {
  font-size: 12px;
  color: #555;
  margin-top: 5px;
}

.number {
  font-size: 16px;
  font-weight: bold;
}

.overview-banner {
  min-height: 260px;
  padding: 20px;
  background: url('../../assets/image/user/overview-bg.png') 100%;
  color: #fff;
  .title {
    font-size: 18px;
    line-height: 28px;
  }
  .user-name {
    font-size: 18px;
    line-height: 28px;
    font-weight: bold;
  }
  .user-phone {
    font-size: 14px;
    margin-top: 4px;
  }
}

.overview-container {
  margin: -120px 20px 0;
}

.capital {
  z-index: 100;
  padding: 26px;
  .total-balance {
    text-align: center;
    margin: 10px 0 26px;
    .number {
      font-size: 26px;
    }
  }
  .revenue {
    display: flex;
    align-items: flex-start;
    text-align: center;
    .yesterday {
      width: 50%;
      border-right: 1px solid rgba(151, 151, 151, .3);
    }
    .cumulative {
      width: 50%;
    }
  }
}

.unused-balance {
  margin-top: 6px;
  padding: 0 10px 10px;
  .balance {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 16px;
    .balance-amount {
      padding-top: 10px;
      .extra-amount {
        margin: 0 -24px 2px 0;
        text-align: right;
        color: color-primary;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .btn-container {
      padding-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
    .btn-item:first-child {
      margin-right: 8px;
    }
    .btn-item /deep/ {
      .md-button {
        font-size: 12px;
        width: auto;
        height: 30px;
      }
    }
  }
  .tip {
    border-top: 1px dashed #eee;
    padding-top: 10px;
    font-size: 9px;
  }
}

.investment-title {
  font-size: 16px;
  color: #878B99;
  font-weight: bold;
  margin: 40px 0 20px;
}

.invest {
  padding: 20px;
  border-top: 3px solid #5cc414;
  .invest-title {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .invest-title-icon {
      width: 21px;
      height: 21px;
      margin-right: 6px;
    }
  }
  .invest-content {
    display: flex;
    justify-content: flex-start;
    .balance {
      width: 60%;
    }
    .revenue {
      width: 40%;
    }
  }
}

.invest-fixed {
  margin: 15px 0 30px;
}

.account-status {
  margin-top: 6px;
}

</style>
